// extracted by mini-css-extract-plugin
export default {"empty":"Exchange_empty__hZvyF","button":"Exchange_button__laFhZ","wechat":"Exchange_wechat__Me5Qx","action":"Exchange_action__zki6i","action_item":"Exchange_action_item__NYif5"};